import { ApiClient } from '~/apiClients/ApiClient';
import { AssignmentAttributes, NdGroup, NdGroupAttributes } from '~/models/NdGroup';

export default class NdGroupApiClient extends ApiClient {
  private readonly BASE_URL: string = '/api/nd-groups';

  public async provideGroups(): Promise<Array<NdGroup>> {
    const response = await this.get(this.BASE_URL);
    return response.data.map((attributes: NdGroupAttributes) => new NdGroup(attributes));
  }

  public async provideAssignedToTracker(trackerId: number): Promise<Array<NdGroup>> {
    const response = await this.get(`${this.BASE_URL}/assigned?trackerId=${trackerId}`);
    return response.data.map((attributes: NdGroupAttributes) => new NdGroup(attributes));
  }

  public async assignToTracker(attributes: AssignmentAttributes) {
    return this.post(`${this.BASE_URL}/assign`, attributes);
  }

  public async unassignFromTracker(attributes: AssignmentAttributes) {
    return this.delete(`${this.BASE_URL}/unassign`, attributes);
  }
}
